/**
 * Formatowanie kwot kokpitu decyzji — jedno miejsce dla „Wartości na liście", kolumn „Netto" /
 * „Brutto" / „Wartość", sum w nagłówkach grup i sekcji oraz wiersza „Razem" w sekcjach kartotek.
 *
 * Formatery `Intl.NumberFormat` są drogie w budowie, a kwoty formatujemy w gorących miejscach
 * (komórki tabel, stopka, nagłówki sekcji — setki wywołań na ekran), więc każdy jest budowany
 * RAZ i trzymany w pamięci modułu.
 */

/**
 * Formatery walutowe wg kodu waluty. `null` = kod, dla którego `Intl` rzuca (nie jest kodem ISO) —
 * zapamiętany, żeby nie próbować budować formatera za każdym razem.
 */
const CURRENCY_FORMATS = new Map<string, Intl.NumberFormat | null>();

function currencyFormat(currencyCode: string): Intl.NumberFormat | null {
  const known = CURRENCY_FORMATS.get(currencyCode);
  if (known !== undefined) return known;
  let format: Intl.NumberFormat | null;
  try {
    format = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currencyCode });
  } catch {
    format = null;
  }
  CURRENCY_FORMATS.set(currencyCode, format);
  return format;
}

/** Formatuje kwotę (tekst `numeric(14,2)`) walutowo; gdy waluta nie jest kodem ISO — liczba z kodem. */
export function formatMoney(amount: string, currencyCode: string): string {
  const n = Number(amount);
  if (!Number.isFinite(n)) return `${amount} ${currencyCode}`;
  const format = currencyFormat(currencyCode);
  return format === null ? `${n.toFixed(2)} ${currencyCode}` : format.format(n);
}
